import React, { useEffect, Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { string, bool, shape } from "prop-types";
import { actions as cedipActions } from "reducers/cedip";
import * as utilsI18n from "util/i18n";

import Notification from "pages/_components/Notification";
import Accordion from "pages/_components/Accordion";
import AccordionItem from "pages/_components/AccordionItem";
import PageLoading from "pages/_components/PageLoading";
import I18n from "pages/_components/I18n";
import GridTable from "pages/_components/GridTable/GridTable";

import MainContainer from "pages/_components/MainContainer";
import gaEventTracker, { events } from "util/gaEventTracker";
import { routerActions } from "connected-react-router";
import { isIOS } from "react-device-detect";
import { stateActive, stateActivePendient } from "util/cedip";
import Drawer from "pages/_components/Drawer/Drawer";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CedipDetailList from "./CedipDetailList";
import CedipHead from "./CedipHead";
import TransmissionsCedip from "./components/TransmissionsCedip";
import handleClickAcceptAction from "../ManagementCedip/hooks/handleClickAcceptAction";
import SideBarCedipForm from "../CedipActions/components/SideBarCedipForm";
import { isCedipTransmitted } from "../../utils";

const CedipDetails = (props) => {
    const { match, isMobile, isDesktop, handleExpandEndorsement } = props;
    const dispatch = useDispatch();
    const { cedipList, optionCedip, fetching, fetchingDownload } = useSelector((state) => state.cedip);
    const { cedipsLength = cedipList.length, selectedCedip } = useSelector((state) => state.cedip);
    const [openSidebar, setOpenSidebar] = useState(false);
    const [idAccion, setIdAccion] = useState("");

    useEffect(() => {
        if (!cedipsLength) {
            const receivedCedipFilters = {
                status: "TODOS",
                pageNumber: 1,
                tabSelected: "ALL",
                createdFrom: null,
                createdTo: null,
                expiredFrom: null,
                expiredTo: null,
                cedipId: match.params.id,
            };
            dispatch(cedipActions.filterCedipList({ ...receivedCedipFilters }));
        }
        dispatch(cedipActions.readCedip(match.params.id));
    }, [cedipsLength, match.params.id]);

    const handleClickCancel = () => {
        setOpenSidebar(false);
    };

    const handleDownloadClick = () => {
        gaEventTracker.triggerEvent(events.pf_detalle_descargar());
        dispatch(cedipActions.downloadDetailCedip(selectedCedip, "pdf"));
    };

    const handleClickActionOption = (idAccionSelected) => {
        setIdAccion(idAccionSelected);
        setOpenSidebar(true);
    };

    const handleClickTransmit = () => {
        dispatch(routerActions.push(`/depositsCedip/transmit/${selectedCedip.cedipId}`));
    };

    const handleClickAdmit = () => {
        dispatch(routerActions.push(`/depositsCedip/admit/${selectedCedip.cedipId}`));
    };

    const renderButtonAction = () => {
        if (selectedCedip.estado === stateActive) {
            return (
                <GridTable className="form-actions grid-table-buttons mb-5">
                    <GridTable.Container columns={12} columnsTemplate="fixed">
                        <GridTable.Data columnStart={5} columnWidth={4}>
                            <CustomButton
                                text={utilsI18n.get("cedips.button.transmit")}
                                func={() => handleClickTransmit()}
                                className="btn-primary flex"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            );
        }

        if (
            optionCedip === "cedip.received" &&
            selectedCedip.estado === stateActivePendient &&
            !isCedipTransmitted(selectedCedip)
        ) {
            return (
                <GridTable className="form-actions grid-table-buttons mb-5">
                    <GridTable.Container columns={12} columnsTemplate="fixed">
                        <GridTable.Data columnStart={3} columnWidth={4}>
                            <CustomButton
                                text={utilsI18n.get("cedip.transmit.repudiate.button.accept")}
                                func={() => handleClickActionOption("transmit.repudiate")}
                                className="btn-primary flex"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={7} columnWidth={4}>
                            <CustomButton
                                text={utilsI18n.get("cedip.transmit.admit.button.accept")}
                                func={() => handleClickAdmit()}
                                className="btn-primary flex"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            );
        }

        if (optionCedip === "cedip.transmited" && selectedCedip.estado === stateActivePendient) {
            return (
                <GridTable className="form-actions grid-table-buttons mb-5">
                    <GridTable.Container columns={12} columnsTemplate="fixed">
                        <GridTable.Data columnStart={5} columnWidth={4}>
                            <CustomButton
                                text={utilsI18n.get("cedip.transmit.anulate.button.accept")}
                                func={() => handleClickActionOption("transmit.anulate")}
                                className="btn-primary flex"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
            );
        }

        return null;
    };

    return (
        <PageLoading loading={fetching || fetchingDownload}>
            {selectedCedip && (
                <Fragment>
                    <Notification scopeToShow="depositCedip/details" />
                    <CedipHead
                        id="cedips.detail.title"
                        backLinkTo="/depositsCedip"
                        className={isIOS ? "cedip-head cedip-head-ios" : "cedip-head"}
                        handleClick={() => handleDownloadClick()}
                        status={selectedCedip.estado}
                        {...props}
                    />
                    <MainContainer className="cedip">
                        {isDesktop && (
                            <div className="acct-number">
                                <I18n id="deposits.certificate.cedip.subtitle" />
                                {` ${selectedCedip.numeroCertificado}`}
                            </div>
                        )}
                        <div className="container">
                            {isMobile && (
                                <div className="box box-primary flex-container">
                                    <div className="acct-number-label">
                                        <I18n id="deposits.certificateTitle" />
                                    </div>
                                    <div className="acct-number">
                                        <strong>
                                            <I18n id="global.number" /> {`${selectedCedip.numeroCertificado}`}
                                        </strong>
                                    </div>
                                </div>
                            )}
                            <CedipDetailList cedip={selectedCedip} {...props} />
                            <Accordion>
                                <AccordionItem
                                    key={selectedCedip.cedipId}
                                    number={1}
                                    toggleAccordion={handleExpandEndorsement}
                                    item={
                                        <span>
                                            <I18n id="cedip.details.transmissions.title" />
                                        </span>
                                    }>
                                    {selectedCedip.transmisiones?.length > 0 ? (
                                        <GridTable className="information">
                                            {selectedCedip.transmisiones.map((transmission, index) => (
                                                <>
                                                    <TransmissionsCedip data={transmission} />
                                                    {index < selectedCedip.transmisiones.length - 1 && (
                                                        <GridTable.Container columns={3} columnsTemplate="fixed">
                                                            <GridTable.Data
                                                                columnStart={1}
                                                                columnWidth={isDesktop && 3}
                                                                rowStart={isDesktop ? 4 : 7}>
                                                                <hr className="dotted" />
                                                            </GridTable.Data>
                                                        </GridTable.Container>
                                                    )}
                                                </>
                                            ))}
                                        </GridTable>
                                    ) : (
                                        <GridTable className="information">
                                            <I18n id="cedips.accordion.noData" />
                                        </GridTable>
                                    )}
                                </AccordionItem>
                            </Accordion>
                        </div>
                        {renderButtonAction()}
                        <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                            <SideBarCedipForm
                                idAccion={idAccion}
                                handleCancel={handleClickCancel}
                                handleAccept={() => handleClickAcceptAction(idAccion, selectedCedip, dispatch)}
                            />
                        </Drawer>
                    </MainContainer>
                </Fragment>
            )}
        </PageLoading>
    );
};

CedipDetails.propTypes = {
    cedipNumber: string.isRequired,
    match: shape().isRequired,
    isMobile: bool.isRequired,
    isDesktop: bool.isRequired,
    handleExpandEndorsement: string.isRequired,
};

export default CedipDetails;
